module.exports = __webpack_public_path__ + "img/web.c04c6e6f.svg";